import React, { useEffect, useState } from 'react';
import './Billing.scss';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatPhoneNo } from '../../../helpers/common';

export interface iFormBillingDetails {
    firstNameBilling: string;
    lastNameBilling: string;
    contactBilling: string;
    emailBilling: string;
    vemailBilling: string;
    passwordBilling: string,
    vpasswordBilling: string
}
export interface BillingAddessProps {
    userType: string | undefined;
    onInputChange: (fieldName: string, value: any) => void;
    formBillingDetails: iFormBillingDetails;
    validationErrors: Record<string, string>;
    billingUser: any;
    isReadOnly: boolean
}
const BillingJapan: React.FC<BillingAddessProps> = ({ userType, onInputChange, formBillingDetails, isReadOnly, validationErrors, billingUser }) => {
    const { t } = useTranslation();
    const handleFieldChange = (fieldName: string, value: any) => {
        onInputChange(fieldName, value); // Notify the parent component about the form change
    };
    const [userData, setUserData] = useState<iFormBillingDetails | undefined>(undefined);
    useEffect(() => {

        if (billingUser) {
            setUserData({
                ...userData,
                firstNameBilling: billingUser.firstName,
                lastNameBilling: billingUser.lastName,
                contactBilling: billingUser.phoneNumber,
                emailBilling: formBillingDetails.emailBilling,
                vemailBilling: "",
                passwordBilling: "",
                vpasswordBilling: ""
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [billingUser]);
    return (
       <div className="Billing" role="region" aria-labelledby="billingSectionHeader">
         <h3 id="billingSectionHeader" className="visually-hidden">{t('BILLING_INFORMATION')}</h3>
         <Col md={6}>
           <Form.Group controlId="lastNameBilling">
             <Form.Label className='visually-hidden' htmlFor="lastNameBilling">{t('LAST_NAME')}</Form.Label>
             <Form.Control
               id="lastNameBilling"
               required
               aria-required="true"
               aria-invalid={!!validationErrors.lastNameBilling}
               aria-describedby={validationErrors.lastNameBilling ? "lastNameBillingError" : undefined}
               placeholder={t('LAST_NAME_REQUIRED')}
               type="text"
               autoComplete="none"
               className={`form-control ${isReadOnly ? "disabled" : ""}`}
               name="lastNameBilling"
               readOnly={isReadOnly}
               value={formBillingDetails.lastNameBilling}
               onBlur={(e) => handleFieldChange('lastNameBilling', e.target.value)}
               onChange={(e) => handleFieldChange('lastNameBilling', e.target.value)}
               isInvalid={!!validationErrors.lastNameBilling}
             />
             <Form.Control.Feedback type="invalid" id="lastNameBillingError" aria-live="polite">
               {validationErrors.lastNameBilling}
             </Form.Control.Feedback>
           </Form.Group>
         </Col>
         <Col md={6}>
           <Form.Group controlId="firstNameBilling">
             <Form.Label className='visually-hidden' htmlFor="firstNameBilling">{t('FIRST_NAME')}</Form.Label>
             <Form.Control
               id="firstNameBilling"
               required
               aria-required="true"
               aria-invalid={!!validationErrors.firstNameBilling}
               aria-describedby={validationErrors.firstNameBilling ? "firstNameBillingError" : undefined}
               placeholder={t('FIRST_NAME_REQUIRED')}
               type="text"
               autoComplete="none"
               className={`form-control ${isReadOnly ? "disabled" : ""}`}
               name="firstNameBilling"
               readOnly={isReadOnly}
               value={formBillingDetails.firstNameBilling}
               onBlur={(e) => handleFieldChange('firstNameBilling', e.target.value)}
               onChange={(e) => handleFieldChange('firstNameBilling', e.target.value)}
               isInvalid={!!validationErrors.firstNameBilling}
             />
             <Form.Control.Feedback type="invalid" id="firstNameBillingError" aria-live="polite">
               {validationErrors.firstNameBilling}
             </Form.Control.Feedback>
           </Form.Group>
         </Col>
         <Col md={6}>
           <Form.Group controlId="contactBilling">
             <Form.Label className='visually-hidden' htmlFor="contactBilling">{t('PHONE_NUMBER')}</Form.Label>
             <Form.Control
               id="contactBilling"
               required
               aria-required="true"
               aria-invalid={!!validationErrors.contactBilling}
               aria-describedby={validationErrors.contactBilling ? "contactBillingError" : undefined}
               placeholder={t('PHONE_NUMBER_REQUIRED')}
               type="text"
               autoComplete="none"
               className={`form-control ${isReadOnly ? "disabled" : ""}`}
               name="contactBilling"
               readOnly={isReadOnly}
               value={formatPhoneNo(formBillingDetails.contactBilling)}
               onBlur={(e) => handleFieldChange('contactBilling', e.target.value)}
               onChange={(e) => handleFieldChange('contactBilling', e.target.value)}
               isInvalid={!!validationErrors.contactBilling}
             />
             <Form.Control.Feedback type="invalid" id="contactBillingError" aria-live="polite">
               {validationErrors.contactBilling}
             </Form.Control.Feedback>
           </Form.Group>
         </Col>
         {userType !== 'loggedIn' && (
           <Col md={6}>
             <Form.Group controlId="emailBilling">
               <Form.Label className='visually-hidden' htmlFor="emailBilling">{t('EMAIL_ADDRESS_COLON')}</Form.Label>
               <Form.Control
                 id="emailBilling"
                 required
                 aria-required="true"
                 aria-invalid={!!validationErrors.emailBilling}
                 aria-describedby={validationErrors.emailBilling ? "emailBillingError" : undefined}
                 placeholder={t('EMAIL_ADDRESS_REQUIRED')}
                 type="email"
                 autoComplete="none"
                 className={`form-control ${isReadOnly ? "disabled" : ""}`}
                 name="emailBilling"
                 readOnly={isReadOnly}
                 value={formBillingDetails.emailBilling}
                 onBlur={(e) => handleFieldChange('emailBilling', e.target.value)}
                 onChange={(e) => handleFieldChange('emailBilling', e.target.value)}
                 isInvalid={!!validationErrors.emailBilling}
               />
               <Form.Control.Feedback type="invalid" id="emailBillingError" aria-live="polite">
                 {validationErrors.emailBilling}
               </Form.Control.Feedback>
             </Form.Group>
           </Col>
         )}
         {userType !== 'loggedIn' && (
           <Col md={6}>
             <Form.Group controlId="vemailBilling">
               <Form.Label className='visually-hidden' htmlFor="vemailBilling">{t('VERIFY_EMAIL_ADDRESS_COLON')}</Form.Label>
               <Form.Control
                 id="vemailBilling"
                 required
                 aria-required="true"
                 aria-invalid={!!validationErrors.vemailBilling}
                 aria-describedby={validationErrors.vemailBilling ? "vemailBillingError" : undefined}
                 placeholder={t('VERIFY_EMAIL_ADDRESS_REQUIRED')}
                 type="email"
                 autoComplete="none"
                 className={`form-control ${isReadOnly ? "disabled" : ""}`}
                 name="vemailBilling"
                 readOnly={isReadOnly}
                 value={formBillingDetails.vemailBilling}
                 onBlur={(e) => handleFieldChange('vemailBilling', e.target.value)}
                 onChange={(e) => handleFieldChange('vemailBilling', e.target.value)}
                 isInvalid={!!validationErrors.vemailBilling}
               />
               <Form.Control.Feedback type="invalid" id="vemailBillingError" aria-live="polite">
                 {validationErrors.vemailBilling}
               </Form.Control.Feedback>
             </Form.Group>
           </Col>
         )}
         {userType !== "loggedIn" && userType === "register" && (
           <Col md={6}>
             <Form.Group controlId="passwordBilling">
               <Form.Label className='visually-hidden' htmlFor="passwordBilling">{t('PASSWORD_COLON')}</Form.Label>
               <Form.Control
                 id="passwordBilling"
                 required
                 aria-required="true"
                 aria-invalid={!!validationErrors.passwordBilling}
                 aria-describedby={validationErrors.passwordBilling ? "passwordBillingError" : undefined}
                 placeholder={t('PASSWORD_REQUIRED_FIELD')}
                 type="password"
                 className={`form-control ${isReadOnly ? "disabled" : ""}`}
                 name="passwordBilling"
                 readOnly={isReadOnly}
                 value={formBillingDetails.passwordBilling}
                 onChange={(e) => handleFieldChange("passwordBilling", e.target.value)}
                 isInvalid={!!validationErrors.passwordBilling}
               />
               <Form.Control.Feedback type="invalid" id="passwordBillingError" aria-live="polite">
                 {validationErrors.passwordBilling}
               </Form.Control.Feedback>
             </Form.Group>
           </Col>
         )}
         {userType !== "loggedIn" && userType === "register" && (
           <Col md={6}>
             <Form.Group controlId="vpasswordBilling">
               <Form.Label className='visually-hidden' htmlFor="vpasswordBilling">{t('VERIFY_PASSWORD')}</Form.Label>
               <Form.Control
                 id="vpasswordBilling"
                 required
                 aria-required="true"
                 aria-invalid={!!validationErrors.vpasswordBilling}
                 aria-describedby={validationErrors.vpasswordBilling ? "vpasswordBillingError" : undefined}
                 placeholder={t('VERIFY_PASSWORD_REQUIRED')}
                 type="password"
                 className={`form-control ${isReadOnly ? "disabled" : ""}`}
                 name="vpasswordBilling"
                 readOnly={isReadOnly}
                 value={formBillingDetails.vpasswordBilling}
                 onChange={(e) => handleFieldChange("vpasswordBilling", e.target.value)}
                 isInvalid={!!validationErrors.vpasswordBilling}
               />
               <Form.Control.Feedback type="invalid" id="vpasswordBillingError" aria-live="polite">
                 {validationErrors.vpasswordBilling}
               </Form.Control.Feedback>
             </Form.Group>
           </Col>
         )}
       </div>
    )
}
export default BillingJapan;